export const PURCHASE_EARLY_TERM_DISCL = 'purchase_earlyTermDiscl';